import { useTranslation } from '@/contexts/i18n-context';
import { SvgProps } from './email';
import styles from './styles.module.css';
import clsx from 'clsx';

export function CancelSvg({ className, ariaLabel }: SvgProps) {
  const { t } = useTranslation();
  return (
    <svg
      role="img"
      aria-label={ariaLabel ?? t('svg.cancel')}
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      viewBox="0 0 80 80"
      className={clsx(className, styles.error)}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40 3.99985C20.1178 3.99985 4 20.1177 4 39.9998C4 59.882 20.1178 75.9998 40 75.9998C59.8822 75.9998 76 59.882 76 39.9998C76 20.1177 59.8822 3.99985 40 3.99985ZM40 68.7999C24.1197 68.7999 11.2 55.8801 11.2 39.9998C11.2 24.1196 24.1197 11.1998 40 11.1998C55.8803 11.1998 68.8 24.1196 68.8 39.9998C68.8 55.8801 55.8803 68.7999 40 68.7999Z"
        fill="inherit"
      />
      <path
        d="M54.9482 30.1133L45.082 39.9775L54.9912 49.8867L49.8779 55L39.9688 45.0908L30.1133 54.9473L25 49.835L34.8564 39.9785L25.043 30.165L30.1562 25.0518L39.9697 34.8652L49.835 25L54.9482 30.1133Z"
        fill="inherit"
      />
    </svg>
  );
}
